<template>
  <div class="flex w-full flex-col">
    <div class="w-full flex-col">
      <CommentItem
        v-for="(item, index) in commentsDataSorted"
        :key="index"
        :item="item"
        :newComment="item.newComment"
        :commentableData="commentableData"
        @setNotulen="setNotulen"
      />
    </div>
    <div class="w-full">
      <CommentInput
        :commentableData="commentableData"
        :parentComment="{}"
        :input="inputData"
        @submitComment="submitComment"
      />
    </div>
  </div>
</template>

<script>
import CommentItem from "./CommentItem.vue";
import CommentInput from "./CommentInput.vue";

export default {
  name: "Comment",
  components: {
    CommentItem,
    CommentInput
  },
  props: {
    comments: {
      type: Array
    },
    commentableData: {
      type: Object
    }
  },
  data() {
    return {
      commentsData: this.comments
    };
  },
  computed: {
    user() {
      return this.$sanctum.getUser();
    },
    inputData() {
      return {
        komentarable_id: this.commentableData.id,
        komentarable_type: this.commentableData.type,
        pengguna_id: this.user.id,
        komentar_id: null
      };
    },
    commentsDataSorted() {
      const commentsData = this.commentsData;
      return commentsData.sort((a, b) => {
        return b.is_notulen - a.is_notulen;
      });
    }
  },
  methods: {
    submitComment(data) {
      const dataModified = { ...data, newComment: true };
      const commentsData = [...this.commentsData, { ...dataModified }];

      this.commentsData = commentsData;
    },
    setNotulen({ commentId, is_notulen }) {
      const commentIndex = this.commentsData.findIndex(data => {
        return data.id == commentId;
      });

      this.commentsData[commentIndex].is_notulen = is_notulen;
    }
  }
};
</script>
